export default "__VITE_ASSET__1cee4aa5__"